module.exports = __webpack_public_path__ + "static/media/webdesign-services-img64.477f1992.jpg";